export const INTERNAL_TRANSACTION_STATUS = {
  created: "created",
  flagged: "flagged",
  pending: "pending",
  completed: "completed",
  failed: "failed",
  reversed: "reversed",
  canceled: "canceled",
} as const;

export const INTERNAL_TRANSACTION_TYPE = {
  withdrawal: "withdrawal",
  deposit: "deposit",
} as const;

export const INTERNAL_TRANSACTION_STATUS_TO_LABEL = {
  [INTERNAL_TRANSACTION_STATUS.created]: "Created",
  [INTERNAL_TRANSACTION_STATUS.flagged]: "Flagged",
  [INTERNAL_TRANSACTION_STATUS.pending]: "Pending",
  [INTERNAL_TRANSACTION_STATUS.completed]: "Completed",
  [INTERNAL_TRANSACTION_STATUS.failed]: "Failed",
  [INTERNAL_TRANSACTION_STATUS.reversed]: "Reversed",
  [INTERNAL_TRANSACTION_STATUS.canceled]: "Canceled",
} as const;

export const INTERNAL_TRANSACTION_STATUS_TO_PROGRESS = {
  [INTERNAL_TRANSACTION_STATUS.created]: 1,
  [INTERNAL_TRANSACTION_STATUS.flagged]: 2,
  [INTERNAL_TRANSACTION_STATUS.pending]: 2,
  [INTERNAL_TRANSACTION_STATUS.completed]: 3,
  [INTERNAL_TRANSACTION_STATUS.failed]: 3,
  [INTERNAL_TRANSACTION_STATUS.reversed]: 3,
  [INTERNAL_TRANSACTION_STATUS.canceled]: 3,
} as const;

export const INTERNAL_TRANSACTION_TYPE_TO_LABEL = {
  [INTERNAL_TRANSACTION_TYPE.withdrawal]: "Withdrawal",
  [INTERNAL_TRANSACTION_TYPE.deposit]: "Deposit",
} as const;
